/**
 * Establecer las frases no peligrosas de SGA.
 * 
 * @param Object state
 * @param nextState
 */
export function setProductSga2subsNotDangers(state, nextState) {
    state.productSga2subsNotDangers = nextState
}
